/* eslint-disable import/prefer-default-export */
import Promise from 'bluebird';
import {
    getAdobePassAuthenticationInfo,
    createGetAuthenticationInfoAction,
    createAndPerformStartAuthenticationAction
} from 'common/actions/authenticationActions';
import selectedContentSelector from 'common/selectors/selectedContentSelector';
import selectedStreamSelector from 'common/selectors/selectedStreamSelector';

export function domainCheck(key) { // client only action
    return () => new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = `https://broadband.espn.com/espn3/auth/watchespn/userData?format=json&product=syndicated&rand=${Date.now()}&key=${key}`;
        script.async = true;
        script.onload = () => {
            resolve(window.ud || {});
        };
        script.onerror = (err) => {
            reject(err);
        };
        document.body.appendChild(script);
    });
}

export function updateAdobeAuthentication() {
    return async (dispatch, getState) => {
        const state = getState();
        const content = selectedContentSelector(state);
        const stream = selectedStreamSelector(state);
        const isAuthenticated = await dispatch(createAndPerformStartAuthenticationAction({ content, stream }));
        if (isAuthenticated) {
            const info = await dispatch(getAdobePassAuthenticationInfo());
            const { providerDialog: { providers: providersFromApi } } = state;
            const providerInfo = providersFromApi.filter(({ abbreviation }) =>
                abbreviation === info.mvpd
            ).shift();
            if (providerInfo) {
                dispatch(createGetAuthenticationInfoAction(providerInfo));
            }
        }
        return isAuthenticated;
    };
}



// WEBPACK FOOTER //
// ./app/webapp/syndicated/actions/index.js